// KPI sayfa başlığı — kicker + büyük başlık + alt satır (uygulama kalıbı: uppercase kicker → h1).

import { KPI_COPY } from "../../lib/kpi-ui";

export function KpiPageHeader({
  title,
  subtitle,
  right,
}: {
  title: string;
  subtitle?: string;
  right?: React.ReactNode;
}): JSX.Element {
  return (
    <div className="flex items-start gap-4 mb-3">
      <div className="flex-1 min-w-0">
        <div
          style={{
            fontSize: "0.7rem",
            fontWeight: 700,
            letterSpacing: "0.08em",
            color: "var(--color-primary)",
            textTransform: "uppercase",
          }}
        >
          {KPI_COPY.kicker}
        </div>
        <h1
          className="text-3xl"
          style={{ fontFamily: "var(--font-display)", color: "var(--color-text)", fontWeight: 400 }}
        >
          {title}
        </h1>
        {subtitle ? (
          <div className="text-sm mt-1" style={{ color: "var(--color-text-2)" }}>
            {subtitle}
          </div>
        ) : null}
      </div>
      {right ? <div className="flex items-center gap-2 mt-6">{right}</div> : null}
    </div>
  );
}
